<div class="logo"></div>
<div class="main-panel" [ngSwitch]="state">
  <ng-container *ngSwitchCase="CommentWidgetState.InProgress">
    <label class="single-header">{{ header }}</label>
    <textarea
      #commentInput
      class="comment-area"
      [(ngModel)]="comment"
      (click)="scrollToButton()"
      (focus)="scrollToButton()"
      placeholder="{{ placeholder }}"
    ></textarea>
    <div class="button-panel">
      <button class="button send-button" (click)="post()">
        {{ sendText }}
        <div class="send-icon"></div>
      </button>
    </div>
  </ng-container>
  <div class="success-panel" *ngSwitchCase="CommentWidgetState.Success">
    <label>{{ doneText }}</label>
  </div>
  <div class="fail-panel" *ngSwitchCase="CommentWidgetState.Fail">
    <label class="header">Error</label>
    <label class="error-text">{{ errorCode | translateCode }}</label>
  </div>
</div>
<div class="empty-bottom-part"></div>
